import React, { useState, useEffect } from 'react';
import Impressum from '../pages/Impressum';
import Datenschutz from '../pages/Datenschutz';

const defaultPrefs = {
  necessary: true,
  youtube: false,
  maps: false,
};

function CookieConsent(props) {
  const [visible, setVisible] = useState(false);
  const [showSettings, setShowSettings] = useState(false);
  const [prefs, setPrefs] = useState(defaultPrefs);

  useEffect(() => {
    const saved = localStorage.getItem('cookiePrefs');
    if (!saved) {
      setVisible(true);
    } else {
      try {
        setPrefs(JSON.parse(saved));
      } catch {
        setPrefs(defaultPrefs);
      }
    }
  }, []);

  const savePrefs = (preferences) => {
    localStorage.setItem('cookiePrefs', JSON.stringify(preferences));
    setVisible(false);
    setShowSettings(false);
  };

  const resetPrefs = () => {
    localStorage.removeItem('cookiePrefs');
    setPrefs(defaultPrefs);
    setVisible(true);
  };

  if (!visible) return null;

  return (
    <div className="fixed inset-0 bg-black/50 flex items-center justify-center z-10">
      <div className="bg-white rounded-xl shadow-lg w-full max-w-lg p-6 overflow-y-auto max-h-[90vh]">
        {!showSettings ? (
          <>
            <h2 className="text-lg font-semibold mb-2">Wir verwenden Cookies</h2>
            <p className="text-sm mb-4">
            Um diese Website zu betreiben, ist es für uns notwendig Cookies zu verwenden. Einige Cookies sind erforderlich, um die Funktionalität zu gewährleisten, andere brauchen wir für unsere Statistik und wieder andere helfen uns dir nur die Werbung anzuzeigen, die dich interessiert. Mehr erfährst du in unserer Datenschutzerklärung.
            </p>
            <div className="flex flex-col gap-2">
              <button
                className="bg-blue-600 text-white py-2 rounded hover:bg-blue-700"
                onClick={() => savePrefs({ ...defaultPrefs, youtube: true, maps: true })}
              >
                Alle zulassen
              </button>
              <button
                className="border py-2 rounded hover:bg-gray-100"
                onClick={() => savePrefs(defaultPrefs)}
              >
                Ablehnen
              </button>
              <button
                className="border py-2 rounded hover:bg-gray-100"
                onClick={() => setShowSettings(true)}
              >
                Einzeln bestätigen
              </button>
            </div>
            <div className="text-sm text-gray-500 mt-4 flex justify-between">
              <div className="underline"><Datenschutz ShowDatenschutz={(value) => props.ShowDatenschutz(value)}/></div>
              <div  className="underline"><Impressum ShowImpressum={(value) => props.ShowImpressum(value)}/></div>
            </div>
          </>
        ) : (
          <>
            <h2 className="text-lg font-semibold mb-4">Cookie Einstellungen</h2>
            <p className="text-sm mb-4">
              Hier können die auf dieser Website verwendeten externen Dienste eingesehen und einzeln zugelassen/abgelehnt werden.
            </p>

            <div className="mb-4">
              <label className="flex items-center gap-2">
                <input type="checkbox" checked disabled />
                <span className="font-medium">Nur notwendige Cookies akzeptieren</span>
              </label>
            </div>

            <div className="mb-4 border-t pt-4">
              <label className="flex items-center gap-2">
                <input
                  type="checkbox"
                  checked={prefs.youtube}
                  onChange={() => setPrefs(p => ({ ...p, youtube: !p.youtube }))}
                />
                <span className="font-medium">YouTube</span>
              </label>
              <p className="text-xs text-gray-600 ml-6">
                Durch die Einbindung von Videos werden personenbezogene Daten an YouTube übermittelt.{' '}
                <a href="#" className="underline text-blue-600">Datenschutzerklärung</a>
              </p>
            </div>

            <div className="mb-4">
              <label className="flex items-center gap-2">
                <input
                  type="checkbox"
                  checked={prefs.maps}
                  onChange={() => setPrefs(p => ({ ...p, maps: !p.maps }))}
                />
                <span className="font-medium">Google Maps</span>
              </label>
            </div>

            <div className="flex flex-col sm:flex-row gap-3 mt-6">
              <button
                className="bg-blue-600 text-white py-2 px-4 rounded hover:bg-blue-700"
                onClick={() => savePrefs(prefs)}
              >
                Auswahl speichern
              </button>
              <button
                className="underline text-sm text-gray-600 hover:text-black"
                onClick={resetPrefs}
              >
                Einstellungen löschen
              </button>
            </div>

            <div className="text-sm text-gray-500 mt-4 flex justify-between">
              <div className="underline"><Datenschutz ShowDatenschutz={(value) => props.ShowDatenschutz(value)}/></div>
              <div  className="underline"><Impressum ShowImpressum={(value) => props.ShowImpressum(value)}/></div>
            </div>


          </>
        )}
      </div>
    </div>
  );
}

export default CookieConsent;
